module.exports = __webpack_public_path__ + "img/tripadvisor_logo.1f5167b4.png";